export function getApiError(error, fallback = "Ocurrió un error inesperado.") {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const detail = typeof data === "string" ? data : data?.mensaje || data?.message || data?.error;
  if (status === 401) return detail || "La sesión expiró o las credenciales no son válidas.";
  if (status === 403) return detail || "No tienes permisos para realizar esta acción.";
  if (status === 404) return detail || "El recurso solicitado no existe.";
  if (status === 409) return detail || "La operación entra en conflicto con datos existentes.";
  if (status >= 500) return "El servidor no pudo completar la operación. Intenta nuevamente.";
  return detail || error?.message || fallback;
}

export const isAuthError = (error) => [401, 403].includes(error?.response?.status);
